import { create } from "zustand"
import { immer } from "zustand/middleware/immer"
import { ProjectInfoShort } from "../models/projects/ProjectInfoShort"

interface LandingPageState {
    project?: ProjectInfoShort
}

interface LandingPageActions {
    setProject: (project?: ProjectInfoShort) => void
}

const initialState: Readonly<LandingPageState> = {
    project: undefined,
}

export const useLandingPageStore = create<LandingPageState & LandingPageActions>()(
    immer((set, get) => ({
        ...initialState,
        setProject: (project?: ProjectInfoShort) =>
            set({
                project,
            }),
    })),
)
